// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-floating-promises, react-hooks/exhaustive-deps */

import PropTypes from "prop-types";
import Tooltip from "rc-tooltip";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Dropdown, Icon, Loader } from "semantic-ui-react";

import * as protocolActions from "../../../../redux/actions/protocolActions";

import { useDispatch } from "react-redux";
import { useAuth0 } from "../../../../auth/auth0";

const ProtocolFavoritingWidget = ({
	clientId,
	protocolId,
	userSettings,
	displayMode = "title",
	refreshPage = false,
}) => {
	const dispatch = useDispatch();
	const { getTokenSilently } = useAuth0();

	const [isFavorited, setIsFavorited] = useState(false);
	const [hasRun, setHasRun] = useState(false);
	const [enabled, setEnabled] = useState(false);

	// Make sure the favorite state is set correctly on first load.
	useEffect(() => {
		setHasRun(true);
	}, []);

	useEffect(() => {
		if (hasRun && userSettings.protocolFavoriteGuids) {
			var isProtocolFavorited = userSettings.protocolIsFavorited(protocolId.toLowerCase());
			setIsFavorited(isProtocolFavorited);
			setEnabled(true);
		}
	}, [hasRun, userSettings.protocolFavoriteGuids]);

	function buttonClicked() {
		setEnabled(false);
		attemptToggleFavorite();
		setIsFavorited(!isFavorited);
	}

	async function attemptToggleFavorite() {
		const accessToken = await getTokenSilently();

		// If we need to favorite the current protocol...
		if (isFavorited != true) {
			dispatch(protocolActions.createProtocolFavorite(clientId, accessToken, protocolId))
				.then(() => {
					userSettings.getProtocolFavoriteGuids(() => setEnabled(true));
					if (refreshPage) {
						window.location.reload(true);
					}
				})
				.catch((err) => {
					toast.error("Failed to favorite protocol.");
					console.error(err);
					setIsFavorited(!isFavorited);
				});
		}
		// Otherwise, if we need to unfavorite the current trial...
		else {
			dispatch(protocolActions.deleteProtocolFavorite(clientId, accessToken, protocolId))
				.then(() => {
					userSettings.getProtocolFavoriteGuids(() => setEnabled(true));
					if (refreshPage) {
						window.location.reload(true);
					}
				})
				.catch((err) => {
					toast.error("Failed to unfavorite a protocol.");
					console.error(err);
					setIsFavorited(!isFavorited);
				});
		}
	}

	return enabled === true ? (
		(() => {
			switch (displayMode) {
				case "title":
					return (
						<Dropdown.Item onClick={buttonClicked}>
							{isFavorited ? (
								<>
									<Icon name="star" size="small" style={{ textAlign: "center", color: "#f2711c" }} />
									<span style={{ color: "#000000" }}>Remove from Favorites</span>
								</>
							) : (
								<>
									<Icon name="star outline" size="small" style={{ textAlign: "center" }} />
									<span style={{ color: "#000000" }}>Add to Favorites</span>
								</>
							)}
						</Dropdown.Item>
					);
				case "table":
					return (
						<Tooltip
							placement="bottom"
							mouseEnterDelay={0}
							mouseLeaveDelay={0}
							trigger="hover"
							overlay={isFavorited ? <p>Unfavorite</p> : <p>Favorite</p>}
							transitionName="rc-tooltip-zoom"
						>
							<a style={{ cursor: "pointer" }} onClick={buttonClicked}>
								{isFavorited ? <Icon name="star" style={{ color: "#f2711c" }} /> : <Icon name="star outline" />}
							</a>
						</Tooltip>
					);
				default:
					return null;
			}
		})()
	) : displayMode === "title" ? (
		<Dropdown.Item onClick={buttonClicked}>
			<Loader
				active
				inline
				size="small"
				style={{ marginRight: ".25rem", marginLeft: "4px", fontSize: 21, width: "1.18em", height: "1em" }}
			/>
			<span style={{ color: "#aaaaaa" }}>Loading Favorites...</span>
		</Dropdown.Item>
	) : displayMode === "table" ? (
		<Loader active inline size="tiny" style={{ padding: "11px 21px", marginRight: "5px" }} />
	) : (
		<Loader active inline size="small" style={{ padding: "11px 21px", marginRight: "5px" }} />
	);
};

ProtocolFavoritingWidget.propTypes = {
	clientId: PropTypes.string,
	protocolId: PropTypes.string,
	userSettings: PropTypes.object,
	displayMode: PropTypes.string,
	refreshPage: PropTypes.bool,
};

export default ProtocolFavoritingWidget;
